import { Box, Row, Title } from '@factorialco/deprecated-design-system'
import { ContractTemplatesFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Taxonomies from './Taxonomies'

type Props = {
  companyTemplatesTaxonomies: ContractTemplatesFragment[]
  showAdditionalCompensationField: boolean
}

const ContractTaxonomies = ({
  companyTemplatesTaxonomies,
  showAdditionalCompensationField,
}: Props) => (
  <Box flexGrow width="full">
    <Row>
      <Row.Col halfWidth>
        <Box paddingRight="s64">
          <Title
            variant="500"
            illustration="contract-handshake"
            title={i18n.t('company_settings.general.employment_data.contract_taxonomies.title')}
            description={i18n.t(
              'company_settings.general.employment_data.contract_taxonomies.description'
            )}
          ></Title>
        </Box>
      </Row.Col>
      <Row.Col halfWidth>
        <Box>
          <Taxonomies
            companyTemplatesTaxonomies={companyTemplatesTaxonomies}
            showAdditionalCompensationField={showAdditionalCompensationField}
          />
        </Box>
      </Row.Col>
    </Row>
  </Box>
)

export default ContractTaxonomies
